/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vault_Section_AudioInputs */

const en_vault_section_audio = /** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`High-Res Galleries`)
};

const id_vault_section_audio = /** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri Resolusi Tinggi`)
};

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const es_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const fr_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const de_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const ja_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const zh_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const ar_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const it_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const ru_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const pt_vault_section_audio = en_vault_section_audio;

/** @type {(inputs: Vault_Section_AudioInputs) => LocalizedString} */
const ko_vault_section_audio = en_vault_section_audio;

/**
* | output |
* | --- |
* | "High-Res Galleries" |
*
* @param {Vault_Section_AudioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const vault_section_audio = /** @type {((inputs?: Vault_Section_AudioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vault_Section_AudioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vault_section_audio(inputs)
	if (locale === "es") return es_vault_section_audio(inputs)
	if (locale === "fr") return fr_vault_section_audio(inputs)
	if (locale === "de") return de_vault_section_audio(inputs)
	if (locale === "ja") return ja_vault_section_audio(inputs)
	if (locale === "zh") return zh_vault_section_audio(inputs)
	if (locale === "ar") return ar_vault_section_audio(inputs)
	if (locale === "id") return id_vault_section_audio(inputs)
	if (locale === "it") return it_vault_section_audio(inputs)
	if (locale === "ru") return ru_vault_section_audio(inputs)
	if (locale === "pt") return pt_vault_section_audio(inputs)
	return ko_vault_section_audio(inputs)
});